var exports = {
  "header": "x24da60e8--91be01--header",
  "desktop": "x24da60e8--91be01--desktop",
  "amount": "x24da60e8--91be01--amount",
  "jobs": "x24da60e8--91be01--jobs",
  "job": "x24da60e8--91be01--job",
};

module.exports = exports;
